export const getExportedDocFilename = (format: string) => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return format === "tax_alert_ro" || format === "tax_alert_en"
    ? `tax_alert_${yyyy}-${mm}-${dd}.docx`
    : `exported_documents_${yyyy}-${mm}-${dd}.${format}`;
};
